import { Action } from "redux";
import { Task } from "redux-saga";
import { ActionPattern, call, cancel, fork, join, takeEvery } from "redux-saga/effects";
import { RootState } from "src/store";
import { select, take } from "typed-redux-saga";

export function* getCurrentCustomer() {
  const currentCustomer = yield* select((state: RootState) => state.generalReducer.applicationReducer.currentCustomer);
  if (currentCustomer.loading !== "has-loaded") throw new Error("Customer has not loaded yet");
  return currentCustomer.data;
}

export function* getContactPerson() {
  const contactPersonDetails = yield* select((state: RootState) => state.generalReducer.applicationReducer.contactPersonDetails);

  if (contactPersonDetails.loading !== "has-loaded") throw new Error("Contact person has not loaded yet");
  return contactPersonDetails.data;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function* takeLatestPerKey<A extends Action, K extends string | number>(pattern: ActionPattern<A>, worker: (action: A) => any, keySelector: (action: A) => K) {
  return fork(function* () {
    const tasks: Record<string | number, Task> = {};

    yield takeEvery<A>(pattern, function* (action) {
      const key: K = yield call<typeof keySelector>(keySelector, action);

      if (tasks[key]) {
        yield cancel(tasks[key]);
      }

      tasks[key] = yield fork<typeof worker>(worker, action);

      yield join(tasks[key]);

      if (tasks[key] && !tasks[key].isRunning()) {
        delete tasks[key];
      }
    });
  });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function* takeLeadingPerKey<A extends Action>(pattern: ActionPattern<A>, worker: (action: A) => any, keySelector: (action: A) => string | number) {
  const tasks: Record<string | number, Task> = {};

  while (true) {
    const action: A = yield take(pattern);
    const key = keySelector(action);

    if (!tasks[key] || !tasks[key].isRunning()) {
      tasks[key] = yield fork(function* () {
        try {
          yield* worker(action);
        } finally {
          delete tasks[key]; // Clean up finished task
        }
      });
    }
  }
}
